<template>
  <div id="nav" :style="styleObject">
    <b-container>
      <b-navbar toggleable="lg" type="light">
        <!-- Left aligned nav items -->
        <b-navbar-nav id="left-nav-items">
          <b-navbar-brand v-scroll-to="{ el: '#swiper-header', offset: -53 }">
            <img src="@/assets/logos/logo_T-red.svg" alt="Rangers logo" />
          </b-navbar-brand>
          <div v-if="!isMobile" id="v-line"></div>
          <img
            v-if="!isMobile"
            class="globelife"
            src="@/assets/logos/logo_GLF-colour.svg"
            alt="Globe Life Field"
          />
        </b-navbar-nav>
        <b-nav-item
          v-if="isMobile"
          id="book-now-button"
          v-scroll-to="{ el: '#BookSuite', offset: -60 }"
          >Book Now</b-nav-item
        >

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <scrollactive
          v-if="windowWidth > 992"
          :offset="63"
          class="nav"
          active-class="active"
        >
          <a
            href="#WhyGroupTickets-selector"
            data-section-selector="#WhyGroupTickets-selector"
            class="scrollactive-item small-nav"
            v-scroll-to="{ el: '#WhyGroupTickets' }"
            >Why Group Tickets?</a
          >
          <a
            href="#PartyAreas-selector"
            data-section-selector="#PartyAreas-selector"
            class="scrollactive-item"
            v-scroll-to="{ el: '#PartyAreas', offset: 0 }"
            >Exclusive Party Areas</a
          >
          <a
            href="#GroupSeating-selector"
            data-section-selector="#GroupSeating-selector"
            class="scrollactive-item"
            v-scroll-to="{ el: '#GroupSeating', offset: -53 }"
            >General Group Seating</a
          >
          <a
            href="#Schedule-selector"
            data-section-selector="#Schedule-selector"
            class="scrollactive-item small-nav"
            v-scroll-to="{ el: '#Schedule', offset: -10 }"
            >2026 Schedule</a
          >
          <a
            href="#Suites-selector"
            data-section-selector="#Suites-selector"
            class="scrollactive-item small-nav"
            v-scroll-to="{ el: '#Suites', offset: -53 }"
            >Suite Rentals</a
          >
        </scrollactive>
        <!-- Center aligned nav items -->
        <b-collapse v-else id="nav-collapse" is-nav>
          <b-navbar-nav class="mx-auto">
            <b-nav-item v-scroll-to="{ el: '#WhyGroupTickets', offset: -10 }"
              >Why Group Tickets?</b-nav-item
            >
            <b-nav-item v-scroll-to="{ el: '#PartyAreas', offset: -53 }"
              >Exclusive Party Areas</b-nav-item
            >
            <b-nav-item v-scroll-to="{ el: '#GroupSeating', offset: -53 }"
              >General Group Seating</b-nav-item
            >
            <b-nav-item
              class="small-nav"
              v-scroll-to="{ el: '#Schedule', offset: -10 }"
              >2026 Schedule</b-nav-item
            >
            <b-nav-item
              class="small-nav"
              v-scroll-to="{ el: '#Suites', offset: -53 }"
              >Suite Rentals</b-nav-item
            >
          </b-navbar-nav>
        </b-collapse>
        <!-- Right aligned nav items -->
        <b-navbar-nav v-if="!isMobile">
          <b-nav-item
            id="book-now-button"
            v-scroll-to="{ el: '#BookSuite', offset: -100 }"
            >Book Now</b-nav-item
          >
        </b-navbar-nav>
      </b-navbar>
    </b-container>
    <div v-if="!isMobile" id="call-bar">
      <b-container>
        <div id="number-section">
          <img src="@/assets/icons/icon_phone.svg" alt="Phone" />
          <a href="tel:9727264377p3">972-RANGERS (X3)</a>
        </div>
      </b-container>
    </div>
  </div>
</template>

<script>
export default {
  name: "Nav",
  data() {
    return {
      whiteWidth: this.calcWhiteWidth(),
      windowWidth: window.innerWidth,
      scrollPosition: null,
    };
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
    window.addEventListener("scroll", this.updateScroll);

    window.addEventListener(
      "resize",
      () => {
        this.windowWidth = window.innerWidth;
      },
      false
    );
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    onResize() {
      this.whiteWidth = this.calcWhiteWidth();
      this.windowWidth = window.innerWidth;
    },
    calcWhiteWidth() {
      return 0.467489 * window.innerWidth - 218.4357;
    },
    updateScroll() {
      this.scrollPosition = window.scrollY;
    },
  },
  computed: {
    styleObject() {
      return this.windowWidth <= 992
        ? `background: linear-gradient(white 53px, $dark-blue 53px)`
        : `background: linear-gradient(to right, white ${this.whiteWidth}px, #002D74 ${this.whiteWidth}px)`;
    },
    isMobile() {
      return this.windowWidth <= 992;
    },
  },
};
</script>

<style lang="scss" scoped>
#nav {
  @media only screen and (max-width: $lg) {
    background: linear-gradient(white 53px, $dark-blue 53px);
  }
  .container {
    @media only screen and (min-width: 1100px) and (max-width: 1200px) {
      margin-left: 4em;
    }
  }
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 99;
  .navbar {
    padding: 5px 0;
    &-nav {
      display: flex;
      flex-direction: row;
      align-items: center;
      @media only screen and (max-width: $lg) {
        flex-direction: column;
      }
    }
    #nav-collapse {
      margin-right: 20px;
      text-align: left;
      @media only screen and (max-width: $lg) {
        height: 100vh;
        width: 100vw;
        margin-right: 0;

        ul {
          margin: 25% 0 50%;
          li:not(:last-child) {
            margin-bottom: 10%;
          }
          a {
            width: 135px;
            line-height: 22px;
          }
        }
      }
    }
    &.navbar-expand-lg {
      justify-content: space-evenly;
    }
  }
  .globelife {
    margin-left: 18px;
  }
  a:hover {
    text-decoration: none;
  }
  .scrollactive-nav {
    //margin-left: 10%;

    @media only screen and (max-width: 1200px) {
      margin-left: 5%;
    }
    @media only screen and (min-width: 1100px) and (max-width: 1200px) {
      padding-left: 6%;
      margin-left: 0;
    }
  }
  .scrollactive-item {
    width: 115px;
    font-size: 13px;
    line-height: 18px;
    letter-spacing: 0;
    font-weight: 500;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.3);
    text-align: left;
    margin: 0 10px;
    @media only screen and (max-width: $xl) {
      margin: 0 5px;
    }
    @media only screen and (max-width: $lg) {
      color: #fff;
      font-family: "BertholdCondensed";
      font-weight: 700;
      font-size: 25px;
    }
    &.active {
      color: #fff;
    }
    &.small-nav {
      width: 90px;
    }
  }
  @media only screen and (max-width: $lg) {
    a {
      width: 130px;
      font-size: 13px;
      line-height: 18px;
      letter-spacing: 0;
      font-weight: 500;
      text-transform: uppercase;
      text-align: center;
      color: rgba(255, 255, 255, 0.3);
      @media only screen and (max-width: $lg) {
        color: #fff;
        font-family: "BertholdCondensed";
        font-weight: 700;
        font-size: 25px;
      }
    }
  }
  a.is-active {
    color: #fff;
    @media only screen and (max-width: $lg) {
      color: $rangers-red;
    }
  }
  #left-nav-items {
    align-items: center;
    #v-line {
      height: 30px;
      width: 1px;
      background-color: $grey;
    }
    a {
      width: 30px;
    }
  }
  .call {
    font-size: 13px;
    line-height: 18px;
    font-weight: 500;
    letter-spacing: 0;
    color: #ffffff;
    margin-right: 17px;
    white-space: nowrap;
    a:hover {
      text-decoration: none;
    }
  }
  #book-now-button {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    width: 120px;
    border-radius: 8px;
    border: none;
    background-color: $rangers-red;
    line-height: 15px;
    text-transform: uppercase;
    white-space: nowrap;
    //margin-left: 5%;
    @media only screen and (max-width: $lg) {
      margin-left: 10px;
    }
    a {
      color: #ffffff;
      font-family: "Gotham";
      font-weight: 900;
      font-size: 13px;
    }
  }
}
#call-bar {
  display: block;
  position: fixed;
  z-index: 11;
  width: 100%;
  left: 0px;
  top: 53px;
  height: auto;
  height: auto;
  text-align: center;
  pointer-events: none;
  cursor: default;
  //background: rgba(4, 12, 24, 0.3);
  background: linear-gradient(
    90deg,
    rgba(4, 12, 24, 0) 0%,
    rgba(4, 12, 24, 0) 50%,
    #040c18 100%
  );
  //backdrop-filter: blur(10px);
  transition: 0.5s;
  #number-section {
    @media only screen and (min-width: $xl) {
      padding-right: 40px;
    }

    img {
      margin: 0 10px;
    }
    display: inline-flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    height: 30px;
    font-weight: 500;
    font-size: 13px;
    a {
      color: #fff;
    }
  }
}
</style>
